import { maskDecimal } from '@givebutter/util';
import { Contact } from 'types/domain';

interface DonorSearchDataPoint {
    label: string;
    value: number | string | undefined;
    description: string;
}
const getDataPoints = (contact: Contact): DonorSearchDataPoint[] => [
    {
        label: 'DonorSearch Rating',
        value: contact.donorsearch?.DS_Rating,
        description:
            'Propensity to give score, DS1-1 is top opportunity, DS1-5 is lowest qualified opportunity, DS3 doesn’t have high quality matched data.',
    },
    {
        label: 'Target Based on Wealth',
        value: contact.donorsearch?.CapacityRangeBasedOnWealth,
        description:
            'This is a giving potential based on a proprietary algorithm that estimates net worth based on known markers of wealth. Range is roughly 10% of the estimated net worth, or 2% per year over a 5 year pledge. This can be used as an aspirational target or a 5-year giving capacity.',
    },
    {
        label: 'Major Gift Likelihood',
        value: contact.donorsearch?.MajorGiftLikelihood,
        description:
            "Rating that shows the prospect's likelihood to be a major gift donor based upon a combination of external giving matches and internal giving history to your organization. 300 = most likely; 0 = least likely. If there is no internal history, the rating will be based on external giving only.",
    },
    {
        label: 'Annual Gift Likelihood',
        value: contact.donorsearch?.AnnualFundLikelihood,
        description:
            "Rating that shows the prospect's likelihood to be an annual fund donor based upon a combination of external giving matches and internal giving history to your organization. 300 = most likely; 0 = least likely. If there is no internal history, the rating will be based on external giving only.",
    },
    {
        label: 'Total Likely External Gift Amount',
        value: maskDecimal(contact.donorsearch?.LikelyMatchesTotal ?? 0),
        description: 'Total dollars the individual likely donated to all charitable organizations.',
    },
    {
        label: 'Lowest External Gift Amount',
        value: maskDecimal(contact.donorsearch?.LargestGiftLow ?? 0),
        description: 'Lower range of the single largest gift the individual gave elsewhere.',
    },
    {
        label: 'Largest Gift Organization',
        value: contact.donorsearch?.LargestGiftOrg,
        description:
            'Name of the organization where the individual made their single largest gift.',
    },
];

export default getDataPoints;
